// extracted by mini-css-extract-plugin
module.exports = {"page_container":"styles_page_container__3Mnzo","table_card":"styles_table_card__1-Nas"};